import { CustomerLanguage } from '@optiflow/types';

/** Form state for both the quick-create and the full edit journeys. */
export interface CustomerFormValues {
  fullName: string;
  mobile: string;
  alternateMobile: string;
  email: string;
  dateOfBirth: string;
  gender: string;
  preferredLanguage: string;
  notes: string;
}

export type CustomerFormErrors = Partial<Record<keyof CustomerFormValues, string>>;

/**
 * All fields start as empty strings rather than undefined, so every input stays controlled and
 * React never warns about switching a field from uncontrolled to controlled mid-edit.
 */
export const EMPTY_CUSTOMER_FORM: CustomerFormValues = {
  fullName: '',
  mobile: '',
  alternateMobile: '',
  email: '',
  dateOfBirth: '',
  gender: '',
  preferredLanguage: CustomerLanguage.AR,
  notes: '',
};
